// Cuenta en la barra del editor: «Entrar» o el menú de la cuenta (Inicio, Mis aulas, Cuenta, Salir), y el aviso
// «Entra o crea una cuenta para guardar» cuando se quiere guardar sin cuenta (el borrador local se conserva).
import { logout, loginUrl, registerUrl, ROLE_NAME } from '../session.js';
import { escapeHtml, initials } from './html.js';
import { openModal } from './dialogs.js';

/** Sale del editor a otra página: antes guarda lo pendiente; lo que no tiene dónde guardarse queda como borrador. */
export async function leaveTo(app, url, { save = true } = {}) {
  if (save && !(await app.flushSave()) && !confirm('No se pudieron guardar los últimos cambios (quedan en un borrador de este navegador). ¿Salir de todos modos?')) return;
  app.writeDraft();
  app.leaving = true;
  location.href = url;
}

export function setupAccount(app) {
  const box = document.getElementById('account');
  const render = () => {
    const u = app.user;
    if (!u) {
      box.innerHTML = '<a class="btn ghost login-btn" href="/entrar" data-login aria-label="Entrar"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 12a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9zm0 2c-4.4 0-8 2.2-8 5v2h16v-2c0-2.8-3.6-5-8-5z"/></svg><span>Entrar</span></a>';
      return;
    }
    box.innerHTML = `<div class="menu">
        <button class="btn ghost account-btn" data-menu="cuenta" aria-haspopup="true" aria-expanded="false" title="${escapeHtml(u.name)}">
          <span class="avatar" aria-hidden="true">${escapeHtml(initials(u.name))}</span><span class="sr-only">Cuenta de ${escapeHtml(u.name)}</span></button>
        <div class="menu-list right" data-list="cuenta">
          <div class="menu-head"><b>${escapeHtml(u.name)}</b><small>${escapeHtml(ROLE_NAME[u.role] || '')} · ${escapeHtml(u.login)}</small></div>
          <a href="/inicio" data-leave>Inicio</a>
          <a href="/inicio#aulas" data-leave>Mis aulas</a>
          <a href="/cuenta" data-leave>Cuenta</a>
          <hr>
          <button type="button" data-logout>Salir</button>
        </div>
      </div>`;
  };
  app.on('user', render);
  render();

  document.addEventListener('click', async (e) => {
    const login = e.target.closest('[data-login]');
    const leave = e.target.closest('a[data-leave]');
    const out = e.target.closest('[data-logout]');
    if (!login && !leave && !out) return;
    if ((login || leave) && (e.ctrlKey || e.metaKey || e.shiftKey || e.button !== 0)) return;
    e.preventDefault();
    document.querySelectorAll('.menu.open').forEach((m) => m.classList.remove('open'));
    // Entrar: vuelve a esta misma pantalla, donde se recupera el borrador.
    if (login) return leaveTo(app, loginUrl(location.pathname + location.search), { save: false });
    if (leave) return leaveTo(app, leave.getAttribute('href'), { save: !leave.hasAttribute('data-nosave') });
    if (app.dirty && !app.readOnly && app.kind !== 'review') {
      const saved = await app.flushSave();
      const where = app.projectId || app.saveHandler ? '' : ' (nunca se guardó)';
      if ((!saved || !(app.projectId || app.saveHandler)) && !confirm(`Este proyecto tiene cambios sin guardar${where}. Al salir se borran de este navegador. ¿Salir de todos modos?`)) return;
    }
    let next = null;
    try {
      next = await logout();
    } catch {
      // aunque falle, en este navegador ya no queda nada de la cuenta
    }
    app.leaving = true;
    location.href = next || '/entrar'; // entró con budu: sale también de allá y vuelve a /entrar
  });

  // Guardar sin cuenta, o la sesión terminó: entrar o crear cuenta y volver aquí.
  app.on('need-login', (reason) => {
    const back = location.pathname + location.search;
    const text = {
      save: 'Para guardar tu proyecto en el servidor necesitas una cuenta.',
      copy: 'Para guardar una copia en tus proyectos necesitas una cuenta.',
      expired: 'Tu sesión terminó: vuelve a entrar para seguir guardando.',
    }[reason];
    const note = reason === 'copy'
      ? 'Después de entrar vuelves a esta pantalla.'
      : 'Mientras tanto tu trabajo se conserva en este navegador (borrador local) y se recupera al volver.';
    openModal(
      reason === 'expired' ? 'Vuelve a entrar' : 'Entra o crea una cuenta para guardar',
      `<p style="margin-top:0">${text}</p><p style="color:var(--muted)">${note}</p>
       <div class="modal-actions"><button class="btn" data-close>${reason === 'expired' ? 'Cerrar' : 'Seguir sin cuenta'}</button>
         ${reason === 'expired' ? '' : `<a class="btn" href="${escapeHtml(registerUrl(back))}" data-leave data-nosave>Crear cuenta</a>`}
         <a class="btn primary" href="${escapeHtml(loginUrl(back))}" data-leave data-nosave>Entrar</a></div>`,
      { narrow: true },
    );
  });
}
